class Localization {
  constructor(app) {
    this.app = app;
  }

  async change(postal) {
    try {
      const response = await $.ajax({
        url: window.bvm.ajax,
        method: 'POST',
        data: {
          action: 'update_location',
          location: postal,
        },
      });

      if(response.success) {
        return true;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  async search(args, config) {
    const params = new URLSearchParams();

    const result = {
      total: 0,
      data: [],
    };

    if (args.cache) {
      params.append('cache', args.cache);

      if (args.cachettl) {
        params.append('cachettl', args.cachettl);
      }
    }

    if (args.term) {
      params.append('term', args.term);
    }

    const response = await this.app.api.get('locations', params, config);

    if (response.isSuccess()) {
      response.getData().forEach((item) => {
        result.total += 1;
        result.data.push({
          city: item.city,
          postal: item.zip,
          state: item.region_code,
        });
      });
    } else {
      throw new Error(response.getMessage());
    }

    return result;
  }
}

export default Localization;
